export default __webpack_public_path__ + "static/media/yotta21-Taum.29d6605b.png";